export default class PaymentModalService {
/**
 * @param {string} quantityOrder - The quantity of the order
 * @param {string} subscriptionType - The type of the subscription
 * @param {string} coupon - The coupon code
 * @param {string} currency - The currency of the order
 * @param {string} cardBtnActiion - The action for the card button
 * @param {string} paypalBtnAction - The action for the paypal button
 */
  static setChoosePaymentMethodActions({
    quantityOrder,
    subscriptionType,
    coupon,
    currency,
    cardBtnActiion,
    paypalBtnAction,
  }) {
    const modal = document.querySelector("#choosePaymentMethod");
    const creditCardBtn = modal.querySelector(".btn-credit-card");
    const paypalBtn = modal.querySelector(".btn-paypal");

    creditCardBtn.setAttribute(
      "data-action",
      `click->payment--choose-payment-method-modal#${cardBtnActiion}`
    );
    paypalBtn.setAttribute(
      "data-action",
      `click->payment--choose-payment-method-modal#${paypalBtnAction}`
    );
    currency && modal.setAttribute(
      "data-payment--choose-payment-method-modal-currency-value",
      currency
    );
    coupon &&
      modal.setAttribute(
        "data-payment--choose-payment-method-modal-coupon-value",
        coupon
      );
    quantityOrder &&
      modal.setAttribute(
        "data-payment--choose-payment-method-modal-quantity-order-value",
        quantityOrder
      );
    subscriptionType &&
      modal.setAttribute(
        "data-payment--choose-payment-method-modal-subscription-type-value",
        subscriptionType
      );
  }
}
